import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SignatureType } from 'ngx-mat-esign360';
import { IClientSignField } from '../model/sign-field.model';

export function SignFieldsContactValidator(
  getSignFields: (clientCid: string) => IClientSignField[],
  getClientCid: () => string,
  targetSignatureType: SignatureType.Email | SignatureType.SMS
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const signFields = getSignFields(getClientCid());
    if (
      signFields.some((signField) => signField.type === targetSignatureType) &&
      Validators.required(control)
    ) {
      return {
        signFieldsContactRequired: {
          signatureType: targetSignatureType,
        },
      };
    }
    return null;
  };
}
